<template>
    <div>
        <el-button type="primary" @click="handleSelect">选择</el-button>
        <el-table ref="moviesTable" height="420" size="mini" @selection-change="handleSelectionChange" style="width: 100%" :data="batchnoList" border>
            <el-table-column type="selection" width="55" :selectable="selectEnable"></el-table-column>
            <el-table-column prop="wesCode" label="单据编号" min-width="150" align="center"></el-table-column>
            <el-table-column prop="batchno" label="批号" min-width="150" align="center"></el-table-column>
            <el-table-column prop="prodate" label="生产日期" min-width="150" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.prodate">
                        {{$common.getLocalTime(scope.row.prodate)}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="expidate" label="失效日期" min-width="150" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.expidate">
                        {{$common.getLocalTime(scope.row.expidate)}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="num" label="数量" min-width="100" align="center"></el-table-column>
            <el-table-column prop="codePid" label="WES商品ID" min-width="200" align="center"></el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: "BatchnoSearch",
    props: {
        batchnoList: {
            type: Array,
            default: () => []
        },
        dataList: {
            type: Array,
            default: () => []
        },
        selectDataList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            multipleSelection: [],
            selectData: []
        }
    },
    created() {
        this.$nextTick(() => {
            this.selectData = []
            var arr = []
            this.batchnoList.forEach(item => {
                if (this.dataList.filter(val => val.wesCode == item.wesCode&&val.batchno == item.batchno&&val.prodate == item.prodate&&val.expidate == item.expidate).length > 0) {
                    if (this.selectDataList.filter(val1 => val1.wesCode == item.wesCode&&val1.batchno == item.batchno&&val1.prodate == item.prodate&&val1.expidate == item.expidate).length == 0) {
                        this.selectData.push(item)
                    }
                }
                if (this.selectDataList.filter(val => val.wesCode == item.wesCode&&val.batchno == item.batchno&&val.prodate == item.prodate&&val.expidate == item.expidate).length > 0) {
                    arr.push(item)
                }
            })
            this.$refs.moviesTable.clearSelection()
            arr.forEach(item => {
                this.$refs.moviesTable.toggleRowSelection(item, true);
            })
        })
    },
    beforeDestroy() { },
    methods: {
        selectEnable(row, rowIndex) {
            if (this.selectData && this.selectData.length > 0) {
                var flag = false
                this.selectData.forEach(item => {
                    if (row.wesCode == item.wesCode&&row.batchno == item.batchno&&row.prodate == item.prodate&&row.expidate == item.expidate) {
                        flag = true
                    }
                })
                if (flag) {
                    return false
                }
            }
            return true
        },
        handleSelectionChange(rows) {
            this.multipleSelection = rows;
        },
        handleSelect() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    message: "请选择批号",
                    type: "error",
                });
                return;
            }
            const obj = JSON.parse(JSON.stringify(this.multipleSelection[0]));
            const arr = this.multipleSelection.filter((item) => item.batchno !== obj.batchno);
            if (arr.length > 0) {
                this.$message({
                    message: "请选择相同的批号",
                    type: "error",
                });
                return;
            }
            const wesCodeList = this.multipleSelection.map(item => {
                return {
                    wesCode: item.wesCode,
                    batchno: item.batchno,
                    prodate: item.prodate,
                    expidate: item.expidate
                }
            });
            const num = this.multipleSelection.reduce((total, item) => total + Number(item.num), 0);
            this.$set(obj, 'num', num);
            this.$set(obj, 'wesCodeList', wesCodeList);
            this.$emit("TranData", obj);
        }
    }
}
</script>

<style>
</style>